import {computed, makeObservable, observable, action} from "mobx";

export default class TabsPanelFeature {
    constructor(tabs = []) {
        this._selectedTab = 0;
        this._tabs = tabs;
        this._loaded = false;

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
            _selectedTab: observable,
            selectedTab: computed,
            _tabs: observable,
            tabs: computed,
            changeTab: action,
            _finishLoading: action,
        });
    }

    async load() {
        this._finishLoading();
    }

    get loaded() {
        return this._loaded;
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(value) {
        this._selectedTab = value;
    }

    get tabs() {
        return this._tabs;
    }

    set tabs(value) {
        this._tabs = value;
    }

    changeTab(tabIndex) {
        this._selectedTab = tabIndex;
    }

    hasTabs() {
        return this._tabs && this._tabs.length > 0;
    }

    getSelectedTabId() {
        const value = typeof this._selectedTab === 'number' ? this._selectedTab : 0;
        return Math.min(Math.max(value, 0), Math.max(0, this._tabs.length - 1));
    }

    getCurrentTab() {
        return this._tabs[this.getSelectedTabId()];
    }

    getTabOptions() {
        return this._tabs.map((eachTab, index) => ({
            label: eachTab.label ? eachTab.label() : '',
            icon: eachTab.icon ? eachTab.icon() : undefined,
            title: eachTab.title ? eachTab.title() : '',
            value: index
        }));
    }

    _finishLoading() {
        this._loaded = true;
    }
} 